import React from "react";

import { ConditionalWrapper } from "@utils/helpers";

import { Brand } from "lib/@types/service/product/shared";

import "./brandLogo.scss";

export type BrandLogoProps = {
    brand: Brand;
    brandPagePath?: string;
};

const BrandLogo = ({ brand, brandPagePath }: BrandLogoProps) => {
    if (!brand || !brand.image) {
        return null;
    }

    return (
        <figure
            className="brand-logo-component mb-0"
            data-test={`brandLogo-figure-${brand.name}`}
        >
            <ConditionalWrapper
                condition={!!brandPagePath}
                wrapper={children => (
                    <a href={brandPagePath} title={brand.name}>
                        {children}
                    </a>
                )}
            >
                <img
                    className="brand-logo-component__image"
                    src={brand.image}
                    alt={brand.name}
                />
            </ConditionalWrapper>
        </figure>
    );
};

export { BrandLogo };
